module.exports = __webpack_public_path__ + "img/banner-zc_02.9cd260f7.png";